/**
 * Lazy wrapper around `canvas-confetti`. Imported via dynamic import so
 * the (~10 KB gz) library doesn't ship in the main bundle — it loads only
 * when a reader actually finishes a goal.
 *
 * Respects `prefers-reduced-motion`: when set, the call is a no-op rather
 * than firing a sensory burst at users who explicitly opted out.
 */
export async function launchConfetti(): Promise<void> {
  if (typeof window === 'undefined') return;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  // Dynamic import — `await import(...)` so Vite code-splits this away
  // from the main route bundle.
  const confetti = (await import('canvas-confetti')).default;

  // Two-burst pattern reads more "celebration" than one big burst.
  confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 } });
  setTimeout(() => {
    confetti({ particleCount: 60, spread: 100, origin: { y: 0.7 }, scalar: 1.1 });
  }, 220);
}
